import React from "react"
import type { CSSProperties } from "react"

type CloseIconProps = {
  style?: CSSProperties
  className?: string
}

export default function CloseIcon({ style, className }: CloseIconProps) {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="close_toast_title"
      style={style}
      className={className}
    >
      <title id="close_toast_title" lang="en">
        Close notification
      </title>
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
    </svg>
  )
}
